import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../components/Widget/Widget";

const JiraTablet = () => {

  return (
    <Widget >
      <div className="clearfix height140 relativeDiv">
        <Row className="flex-nowrap">
          <Col xs={3}>
            <img
              src="/icons/views.png"
              width={window.innerWidth < 1576 ? "40" : "60"}
            />
          </Col>
          <Col xs={9}>
            <h6 className="m-0">EA Tablet</h6>
            <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={500}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        <Row className="flex-nowrap marginTop36">
          <Col xs="4">
            <h6 className="m-0">Open</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={5}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={4}>
            <h6 className="m-0">Re-Open</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={1}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>

          <Col xs={4}>
            <h6 className="m-0">Closed</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={494}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        
      </div>
    </Widget>
  );
};

export default JiraTablet;
